const VacationFriendInitialText ="It is usually more fun to go on vacation with a " +
    "friend.  That way, you have someone to share the experience with. " +
    "What do you think?  Would you like to go with a friend or do you prefer to " +
    "travel alone?"
        
export default VacationFriendInitialText 
 